export const handleEventListener = (
  eventName: string,
  eventFn: (event: CustomEvent) => void,
  action: string
) => {
  switch (action) {
    case 'add': {
      window.addEventListener(eventName, eventFn as EventListener)
      break
    }
    case 'remove': {
      window.removeEventListener(eventName, eventFn as EventListener)
      break
    }
    default: {
      break
    }
  }
}

export const isActiveRoute = (currentPath: string, routePath: string) =>
  currentPath === routePath || currentPath.includes(routePath)
